export default [
  {
    path: '/activity-20250909-main-v2',
    component: () => import('./Page.vue'),
    meta: { expire: '2025-09-20T23:59:59.000+08:00', title: '秋日集市' },
  },
  {
    path: '/activity-20250909-rule-v2',
    component: () => import('./Rule.vue'),
    meta: { expire: '2025-09-20T23:59:59.000+08:00', title: '秋日集市-规则说明' },
  },
]
